/// CONFIG ///

const CONFIG = {
    APP_TITLE: 'Настоящий',
    API_IP: '62.109.20.146',
    API_DOMAIN: 'https://nastoyashchiy.ru/',
    API_C_DOMAIN: 'https://nastoyashchiy.ru',
    API_GATE: 'https://nastoyashchiy.ru/api.php',
    PHONE: '43543543534',
    MINIMAL: 2000,
    MINIMAL_OPT: 3000,
    MINIMAL_KAD: 4000,
    CP_PUBLIC_ID: 'sdfsdf',
    INSTAGRAM_URL: 'https://www.instagram.com/sdfsdfdsfsd/',
    PHONE: '+7 985 447-70-85'
};

export default CONFIG;